let cpcDescriptionMapPromise: Promise<Record<string, string>> | null = null;

const normalizeCode = (value: string | null | undefined) =>
  (value || '').toString().trim().toUpperCase().replace(/\s+/g, '');

export const loadCpcDescriptionMap = async () => {
  if (!cpcDescriptionMapPromise) {
    cpcDescriptionMapPromise = fetch('/cpc_label_map.json')
      .then(async (response) => {
        if (!response.ok) throw new Error('Failed to load CPC descriptions');
        return (await response.json()) as Record<string, string>;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.warn('Failed to load CPC description map:', error);
        return {};
      });
  }

  return cpcDescriptionMapPromise;
};

export const resolveCpcDescription = (
  code: string | null | undefined,
  descriptionMap: Record<string, string>
) => {
  const normalized = normalizeCode(code);
  if (!normalized) return '';

  const exact = descriptionMap[normalized];
  if (exact) return exact;

  const subclass = normalized.match(/^([A-HY]\d{2}[A-Z])/i)?.[1] || '';
  if (subclass && descriptionMap[subclass]) return descriptionMap[subclass];

  const clazz = normalized.match(/^([A-HY]\d{2})/i)?.[1] || '';
  if (clazz && descriptionMap[clazz]) return descriptionMap[clazz];

  const section = normalized.match(/^([A-HY])/i)?.[1] || '';
  if (section && descriptionMap[section]) return descriptionMap[section];

  return '';
};
